import request from "project-config/services/request/request";
import { IVerifyRechargeCodeParams } from "../types";

export interface CreatePaypalBcdcOrderParams {
  amount: number;
  currency: number;
  agent: string;
  socketIp?: string;
  presentType?: number;
  rechargeGoal?: number;
  activityDetailId?: number;
  couponActivityId?: number;
  couponNo?: string;
  rechargeChannels?: number;
}

export interface CapturePaypalBcdcOrderParams {
  payRecordId: string;
  paypalOrderId: string;
}

export const FoxTopUpAPI = Object.freeze({
  verifyRechargeCode: (params: IVerifyRechargeCodeParams) => {
    return request.post(
      "/api/rendering/pay/recharge/verifyRechargeCode",
      params
    );
  },
  createPaypalBcdcOrder: (params: CreatePaypalBcdcOrderParams) => {
    return request.post(
      "/api/rendering/pay/payment/createPaypalBcdcOrder",
      params
    );
  },
  capturePaypalBcdcOrder: (params: CapturePaypalBcdcOrderParams) => {
    return request.post(
      "/api/rendering/pay/payment/capturePaypalBcdcOrder",
      params
    );
  },
});
